module.exports = __webpack_public_path__ + "img/FB.26e9b9ba.gif";